import { PrivatePhotos } from '../../components/TherapistAdminChat';
import './ConsultationsTab.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ProfileRequests.css';
const path = '/api/agregator/administration/profile-requests';
export default function ProfileRequests() {
  const [items, setItems] = useState([]),
    [filter, setFilter] = useState('pending'),
    [search, setSearch] = useState(''),
    [error, setError] = useState(''),
    [loading, setLoading] = useState(true),
    [busy, setBusy] = useState(null),
    [responses, setResponses] = useState({});
  const load = () => axios.get(path, {
    withCredentials: true
  }).then(r => setItems(r.data));
  useEffect(() => {
    load().catch(e => setError(e.response?.data?.message || 'Не удалось загрузить заявки.')).finally(() => setLoading(false));
  }, []);
  async function review(row, status) {
    if (!window.confirm(status === 'approved' ? 'Подтвердить, что вы внесли запрошенные изменения в профиль?' : 'Отклонить заявку?')) return;
    setBusy(row.id);
    setError('');
    try {
      await axios.patch(path + '/' + row.id, {
        status,
        response: responses[row.id] || ''
      }, {
        withCredentials: true
      });
      await load();
    } catch (e) {
      setError(e.response?.data?.message || 'Не удалось сохранить решение.');
    } finally {
      setBusy(null);
    }
  }
  const visible = items.filter(r => (filter === 'all' || r.status === filter) && (r.therapist_name+' '+r.message).toLowerCase().includes(search.toLowerCase()));
  return <section className="admin-consultations profile-requests"><div className="ac-heading"><div><h2>Изменения профилей</h2><p>Найдено: {visible.length}</p></div></div><div className="ac-filters ac-filters-compact"><label className="ac-search">Поиск<input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Терапевт или текст заявки"/></label><label>Статус<select value={filter} onChange={e=>setFilter(e.target.value)}><option value="pending">На рассмотрении</option><option value="approved">Изменения внесены</option><option value="rejected">Отклонена</option><option value="all">Все заявки</option></select></label><button onClick={()=>{setSearch('');setFilter('pending');}}>Сбросить</button></div>{error && <p role="alert">{error}</p>}{loading ? <p>Загрузка…</p> : visible.map(r => <article key={r.id}><div className="pr-heading"><h3>{r.therapist_name}</h3><span>{r.status === 'pending' ? 'На рассмотрении' : r.status === 'approved' ? 'Изменения внесены' : 'Отклонена'}</span></div><small>{new Date(r.created_at).toLocaleString('ru-RU')}</small><p className="pr-message">{r.message}</p><PrivatePhotos items={r.attachments} admin/><a href={'/admin?section=users&user=' + r.therapist_id} target="_blank" rel="noreferrer">Открыть редактирование профиля ↗</a>{r.status === 'pending' ? <><label>Ответ специалисту<textarea rows={3} maxLength={4000} value={responses[r.id] || ''} onChange={e => setResponses({
            ...responses,
            [r.id]: e.target.value
          })} /></label><div className="pr-actions"><button disabled={busy !== null} onClick={() => review(r, 'approved')}>Изменения внесены</button><button disabled={busy !== null || !responses[r.id]?.trim()} onClick={() => review(r, 'rejected')}>Отклонить с пояснением</button></div></> : r.response && <p>Ответ: {r.response}</p>}</article>)}{!loading && !visible.length && <p>Заявок пока нет.</p>}</section>;
}
